import React, { useMemo } from 'react';
import {
  Box,
  Card,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import KeyTermsAndDefinitionsAdmin from './PartnerResources/KeyTermsAndDefinitionsAdminPanel';
import PoliciesAdmin from './PartnerResources/PoliciesAdminPanel';
import BestPracticeTranslations from './PartnerResources/BestPracticeTranslations';
import MemberGroupDiscounts from './PartnerResources/MemberGroupDiscounts';

const Categories = {
  POLICIES: 'policies',
  KEY_TERMS: 'key-terms',
  MEMBER_DISCOUNTS: 'member-group-discounts',
  BEST_PRACTICES: 'mpa-best-practices',
};

export default function PartnerResourcesAdminPanel() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category');

  const handleCategoryChange = (categoryParam: string) => {
    const path = `/admin/partner-resources?category=${categoryParam}`;
    navigate(path);
  };

  const invalidCategory = useMemo(() => category && !Object.values(Categories).includes(category), [category]);

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', width: '100%' }}>
      <Card sx={{ width: 250, p: 1, flexShrink: 0 }}>
        <Typography variant="subtitle1" sx={{ px: 1.5, py: 1, opacity: 0.8, fontWeight: 'semibold' }}>
          Categories
        </Typography>

        <List dense disablePadding>
          <ListItemButton
            selected={category === Categories.KEY_TERMS}
            onClick={() => handleCategoryChange(Categories.KEY_TERMS)}>
            <ListItemText primary="Key Terms & Definitions" />
          </ListItemButton>
          <ListItemButton
            selected={category === Categories.POLICIES}
            onClick={() => handleCategoryChange(Categories.POLICIES)}>
            <ListItemText primary="Policies" />
          </ListItemButton>
          <ListItemButton
            selected={category === Categories.BEST_PRACTICES}
            onClick={() => handleCategoryChange(Categories.BEST_PRACTICES)}>
            <ListItemText primary="MPA Best Practices" />
          </ListItemButton>
          <ListItemButton
            selected={category === Categories.MEMBER_DISCOUNTS}
            onClick={() => handleCategoryChange(Categories.MEMBER_DISCOUNTS)}>
            <ListItemText primary="Member Group Discounts" />
          </ListItemButton>
        </List>
      </Card>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <div style={{ width: '100%' }}>
          { category === Categories.KEY_TERMS && <KeyTermsAndDefinitionsAdmin /> }
          { category === Categories.POLICIES && <PoliciesAdmin /> }
          { category === Categories.BEST_PRACTICES && <BestPracticeTranslations /> }
          { category === Categories.MEMBER_DISCOUNTS && <MemberGroupDiscounts /> }
          {invalidCategory && (
            <Typography variant="h6" align="center" sx={{ mt: 4, opacity: 0.6 }}>
              Please select a valid category.
            </Typography>
          )}
        </div>
      </Box>
    </Box>
  );
}
